export default __webpack_public_path__ + "static/media/icertificate02.8bbe577a.png";